<ng-container *ngFor="let step of steps">
  <a *ngIf="!step.active && isClickable" [routerLink]="step.route">
    <div class="step clickable">
      <div class="body-4 bold step-number">
        {{ step.step }}
      </div>
      <p class="description body-5 bold" *ngIf="showDescription">
        {{ step.description }}
      </p>
    </div>
  </a>

  <div *ngIf="!step.active && !isClickable" class="step">
    <div class="body-4 bold step-number">
      {{ step.step }}
    </div>
    <p class="description body-5 bold" *ngIf="showDescription">
      {{ step.description }}
    </p>
  </div>

  <div *ngIf="step.active" class="step active">
    <div class="body-4 bold step-number">
      {{ step.step }}
    </div>
    <p class="description body-5 bold">
      {{ step.description }}
    </p>
  </div>
</ng-container>
